export default function useIsoDateFormat(isoDate) {
  const d = new Date(isoDate);
  const formattedDate = d.toLocaleDateString('en-US');
  return formattedDate;
}
